import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Menu from '@material-ui/core/Menu'
import { withStyles } from '@material-ui/core/styles'
import { KeyboardArrowDown } from '@material-ui/icons'
import React from 'react'

const styles = () => ({
  button: {
    padding: 0,
    minWidth: 40,
    minHeight: 40,
  },
})

class SimpleMenu extends React.Component {
  state = {
    anchorEl: null,
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { anchorEl } = this.state
    const { classes, children } = this.props
    return (
      <div>
        <Button
          className={classes.button}
          variant="outlined"
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <KeyboardArrowDown />
        </Button>
        <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose}>
          <ClickAwayListener onClick={this.handleClose} onClickAway={this.handleClose}>
            {children}
          </ClickAwayListener>
        </Menu>
      </div>
    )
  }
}

export default withStyles(styles)(SimpleMenu)
